module.exports = __webpack_public_path__ + "static/homer500-167e95e3831e9c00509149f49d2afdec.jpg";